module.exports = __webpack_public_path__ + "img/tips-water-icon.1026403d.svg";